var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.customComponent,{tag:"component",attrs:{"componentData":_vm.item},on:{"saveComponent":_vm.saveItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }